module.exports = __webpack_public_path__ + "img/wallet.340bf4a2.png";